/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Canvas1/view.blocks to change it.
import Canvas from 'DesignSystem/Canvas/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default class Canvas1 extends React.Component {
  render() {
    let { props: {
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/CaptureFeed/Content/Canvas",
  innerRef
  
} } = this
    return (<React.Fragment
>
<Canvas
  viewPath={`${viewPath}/Canvas`}
 ref={innerRef}
 display="none"
 position="absolute"
 top={0}
 left={0}
 bottom={0}
 right={0}
 height="100%"
 maxWidth="100%"
 marginTop={0}
 marginBottom={0}
 marginLeft="auto"
 marginRight="auto"
/>
{children}
</React.Fragment>)
  }
}